import { Tabs as TabsKit, TabsList, TabsTrigger } from "@counselpro/counselkit";
import { useState } from "react";
import { Link } from "./clickable";

export default function Tabs({ tabs, children: tabsContent, initialTab = 0 }) {
  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <>
      <TabsKit value={tabs[activeTab].href}>
        <TabsList>
          {tabs.map((tab, index) => (
            <Link key={tab.label} href={tab.href}>
              <TabsTrigger onClick={() => setActiveTab(index)} value={tab.href}>
                {tab.label}
              </TabsTrigger>
            </Link>
          ))}
        </TabsList>
      </TabsKit>
      {tabsContent && tabsContent[activeTab]}
    </>
  );
}
